import { observable, action } from 'mobx';

const Todos = [
  {
    uid: "1",
    userId: "",
    isCompleted: false,
    isImportant: false,
    isStarred: false,
    isTrashed: false,
    title: "Fix Responses",
    labels: ["frontend", "backend"],
    description: "Jelly topping toffee bear claw. Sesame snaps lollipop macaroon croissant cheesecake pastry cupcake."
  },
  {
    uid: "2",
    userId: "",
    isCompleted: false,
    isImportant: false,
    isStarred: false,
    isTrashed: false,
    title: "Meet Jane",
    labels: ["frontend"],
    description: `Jelly topping toffee bear claw. Sesame snaps lollipop macaroon croissant cheesecake pastry cupcake. 
                  Jelly topping toffee bear claw. Sesame snaps lollipop macaroon croissant cheesecake pastry cupcake.`
  },
  {
    uid: "3",
    userId: "",
    isCompleted: false,
    isImportant: false,
    isStarred: false,
    isTrashed: false,
    title: "Skype Call to Jay",
    labels: ["bug"],
    description: "Jelly topping toffee bear claw. Sesame snaps lollipop macaroon croissant cheesecake pastry cupcake."
  }
];

const BlankTodo = {
  uid: "",
  userId: "",
  title: "",
  isCompleted: false,
  isImportant: false,
  isStarred: false,
  isTrashed: false,
  labels: [],
  description: "",
  createdOn: new Date().toDateString()
};

class TodoStore {
  @observable todos = [];
  @observable todo = {
    uid: "",
    userId: "",
    title: "",
    isCompleted: false,
    isImportant: false,
    isStarred: false,
    isTrashed: false,
    labels: [],
    description: "",
    createdOn: new Date().toDateString()
  };

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @action getTodos = () => {
    const dump = [];
    this.todos = Todos.map((todo) => {
      if(!todo.isTrashed) {
        dump.push(todo)
      }
    })
    this.todos = dump;
  }

  @action setAttribute = (attrName, attrValue) => {
    this.todo[attrName] = attrValue;
  }

  @action toggleAttributes = (attrName, todo) => {
    const { uid } = todo;
      if (uid) {
        let index = Todos.findIndex(item => item.uid === uid);
        if (index > -1) {
          Todos[index][attrName] = !todo[attrName]
        }
    }
    this.todos = Todos;
  }

  @action tagTodo = (name) => {
    let status = this.todo.labels.includes(name);
    if(status) {
      let index = this.todo.labels.findIndex(todo => todo === name);
      this.todo.labels.splice(index, 1);
    } else {
      this.todo.labels.push(name);
    }
  }

  @action moveToBin = (id) => {
    Todos.find(i => i.uid === id).isTrashed = true;
    this.getTodos()
  }

  @action setBlankTodo = () => {
    this.todo = BlankTodo;
  }

  @action setTodo = (data) => {
    this.todo = data;
  }

  @action saveTodo = () => {
    const { uid } = this.todo;
    if (uid) {
      let index = Todos.findIndex(item => item.uid === uid);
      if (index > -1) {
        Todos[index] = this.todo;
      }
    } else {
      Todos.push({
        ...this.todo,
        uid: Math.random()
      });
    }
    this.todos = Todos;
  }

}

export default TodoStore;
